/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_NoteInputs */

const en_login_note = /** @type {(inputs: Login_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No password needed. Your passkey is kept safe in iCloud Keychain or Google Password Manager.`)
};

const de_login_note = /** @type {(inputs: Login_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Passwort nötig. Dein Passkey liegt sicher im iCloud-Schlüsselbund oder im Google Passwortmanager.`)
};

/**
* | output |
* | --- |
* | "No password needed. Your passkey is kept safe in iCloud Keychain or Google Password Manager." |
*
* @param {Login_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_note = /** @type {((inputs?: Login_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_note(inputs)
	return en_login_note(inputs)
});